import Vuex from "vuex";
import Vue from "vue";
import abstract from './abstract';
import socialhub from './socialhub';
import user from './user';
import event from './event';
import eventdashboard from './eventdashboard';
import speakers from './speakers';
import groups from './groups';
import tags from './tags';
import areamaps from './areamaps';
import automatedmessages from './automatedmessages';
import packets from './packets';
import days from './days';
import subevents from './subevents';
import subeventrecords from './subeventrecords';
import coupons from './coupons';
import venues from './venues';
import program from './program';
import saloons from './saloons';
import sponsors from './sponsors';
import participants from './participants';
import payments from './payments';
import vouchertemplates from './vouchertemplates';
import registrationforms from './registrationforms';
import eventalbum from './eventalbum';
import subeventregistrations from './subeventregistrations';
import livesessions from './livesessions';
import scenes from './scenes';
import polls from './polls';
import walls from './walls';
import files from './files';
import social from './social';
import stands from './stands';
import participantInfo from './participantInfo';
import voucher from './voucher';
import usages from './usages';
import promotions from './promotions';
import printschemes from './printschemes';
import promotionhistory from './promotionhistory';
import standcheckins from './standcheckins';
import networking from './networking';
import users from './users';
import surveys from './surveys';
import surveydetails from './surveydetails';
import accesslogs from './accesslogs';
import packetcategory from './packetcategory';
import rsvp from './rsvp';
import rsvptags from './rsvptags';
import rsvptemplates from './rsvptemplates';
import eventprogram from './eventprogram';
import programrate from './programrate';
import questionlibrary from './questionlibrary';
import organization from './organization';
import registerform from './registerform';
import subscription from './subscription';
import definition from './definition';
import additionalProducts from "./additionalProducts";
Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    additionalProducts,
    abstract,
    automatedmessages,
    eventprogram,
    definition,
    organization,
    subscription,
    eventalbum,
    user,
    event,
    speakers,
    groups,
    tags,
    areamaps,
    programrate,
    files,
    questionlibrary,
    packets,
    days,
    subevents,
    coupons,
    venues,
    program,
    saloons,
    sponsors,
    participants,
    eventdashboard,
    payments,
    vouchertemplates,
    socialhub,
    registerform,
    registrationforms,
    subeventregistrations,
    livesessions,
    subeventrecords,
    scenes,
    polls,
    walls,
    social,
    stands,
    participantInfo,
    voucher,
    usages,
    promotions,
    printschemes,
    promotionhistory,
    standcheckins,
    networking,
    users,
    surveys,
    surveydetails,
    accesslogs,
    packetcategory,
    rsvp,
    rsvptags,
    rsvptemplates,
  },
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js